import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class StockTakeSessionRecordQueryCriteriaClass extends BaseCriteriaModel {
  guid_comp?: Optional<string> = Optional.empty();
  guid_branch?: Optional<string> = Optional.empty();
  guid_session_hdr?: Optional<string> = Optional.empty();
  guid_session_device?: Optional<string> = Optional.empty();
}

export class StockTakeSessionRecordCriteriaModelQuery {
  query = '';

  constructor(stockTakeSessionRecordCriteriaModel: StockTakeSessionRecordQueryCriteriaClass) {

    if (!stockTakeSessionRecordCriteriaModel) {
      return;
    }
    console.log('stockTakeSessionRecordCriteriaModel',stockTakeSessionRecordCriteriaModel)
    this.query += stockTakeSessionRecordCriteriaModel.guid_comp.filter(x => x !== '').map(x => '&guid_comp=' + x).orElse('');
    this.query += stockTakeSessionRecordCriteriaModel.guid_branch.filter(x => x !== '').map(x => '&guid_branch=' + x).orElse('');
    this.query += stockTakeSessionRecordCriteriaModel.guid_session_hdr.filter(x => x !== '').map(x => '&guid_session_hdr=' + x).orElse('');
    this.query += stockTakeSessionRecordCriteriaModel.guid_session_device.filter(x => x !== '').map(x => '&guid_session_device=' + x).orElse('');

    this.query += '&calcTotalRecords=' + stockTakeSessionRecordCriteriaModel.calcTotalRecords;
    this.query += '&status=' + stockTakeSessionRecordCriteriaModel.status;
    this.query += '&orderBy=' + stockTakeSessionRecordCriteriaModel.orderBy;
    this.query += '&order=' + stockTakeSessionRecordCriteriaModel.order;
    this.query += '&offset=' + stockTakeSessionRecordCriteriaModel.offset + '&limit=' + stockTakeSessionRecordCriteriaModel.limit;
  }
}
